import React, { useState, useMemo, useEffect } from 'react';
import { Collapse } from "@mui/material";
import PokesolTextModal from '../../LeftSideBar/PokesolTextModal';
import StatsDisplayHeader from '../StatsDisplayHeader';
import StatTableInput from '../StatTableInput';
import AbilityEffectsComponents from '../AbilityEffectsComponents';
import type { InputStatsSharedProps } from '../../types/input-stats-props';
import type { StatInputs } from '../../types/stat';

function InputStatsCore({ 
  selectedPokemon, 
  setSelectedPokemon, 
  statInputs, 
  handleStatChange, 
  handlePersonalityChange, 
  createIncrementHandler, 
  createDecrementHandler, 
  totalEvs,
  handleIndividualValueChange 
}: InputStatsSharedProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const [isStatsExpanded, setIsStatsExpanded] = useState(true); // デフォルトで開いた状態
  
  // ローカル状態で値のみを管理（ダメージ計算は実行しない）
  const [localStatInputs, setLocalStatInputs] = useState(statInputs);
  
  // 外部のstatInputsが変更された時にローカル状態を同期
  useEffect(() => {
    setLocalStatInputs(statInputs);
  }, [statInputs]);
  
  // 値の更新のみを行う関数（ダメージ計算なし）
  const updateLocalStat = (statName: keyof Pick<StatInputs, "hp_effort" | "attack_effort" | "defense_effort" | "special_attack_effort" | "special_defense_effort" | "speed_effort">, value: number) => {
    setLocalStatInputs(prev => {
      // 新しい値での合計EV計算
      const newStatInputs = {
        ...prev,
        [statName]: value
      };
      
      
      // 表示用のローカル状態なのでこの段階では制限をかけない
      return newStatInputs;
    });
  };

  // ローカル状態での合計EV計算
  const localTotalEvs = useMemo(() => {
    return Object.keys(localStatInputs)
      .filter(key => key.endsWith('_effort'))
      .reduce((total, key) => {
        return total + (localStatInputs[key as keyof StatInputs] as number);
      }, 0);
  }, [localStatInputs]);

  return (
    <>
      <StatsDisplayHeader
        selectedPokemon={selectedPokemon}
        localStatInputs={localStatInputs}
        localTotalEvs={localTotalEvs}
        isStatsExpanded={isStatsExpanded}
        setIsStatsExpanded={setIsStatsExpanded}
        setModalOpen={setModalOpen}
      />

      <Collapse in={isStatsExpanded}>
        <StatTableInput
          selectedPokemon={selectedPokemon}
          setSelectedPokemon={setSelectedPokemon}
          localStatInputs={localStatInputs}
          updateLocalStat={updateLocalStat}
          handleStatChange={handleStatChange}
          handlePersonalityChange={handlePersonalityChange}
          handleIndividualValueChange={handleIndividualValueChange}
        />
      </Collapse>

      <AbilityEffectsComponents
        selectedPokemon={selectedPokemon}
        setSelectedPokemon={setSelectedPokemon}
      />
      
      {modalOpen && (
        <PokesolTextModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          pokemon={selectedPokemon}
          statInputs={statInputs}
        />
      )}
    </>
  );
}

export default InputStatsCore;
